import { Paper, Typography } from "@mui/material";
import SensorAverageChart from "../chart/sensorAverageChart.component";
import { getMeasuresLabel } from "../chart/utils";
import { useSelector } from "react-redux";
import { selectFormattedAverageData } from "../../store/selectors/sensorAverageSelectors";

const MonitoringAverageChart = ({ measures, sensors, scope }) => {
  const formattedChartData = useSelector((state) => selectFormattedAverageData(state, scope));
  const paramsList = getMeasuresLabel(sensors);

  return (
    <Paper elevation={0} sx={{ width: "50%", height: "350px", padding: 1 }}>
      <Typography fontWeight="bold" fontSize="12px">
        Valori medi
      </Typography>
      <SensorAverageChart
        chartData={formattedChartData}
        selectedMeasures={measures}
        paramsList={paramsList}
      />
    </Paper>
  );
};

export default MonitoringAverageChart;
